import React from 'react';
import { Spinner } from 'react-bootstrap';
import { IconType } from 'components/DesignSystem/Icon/icons';
import Button, { ButtonType } from 'components/DesignSystem/Button';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import './index.scss';

export default function ActionButton({
  loading = false,
  onClick,
  tooltipText = '',
  disabled = false,
  className = '',
  icon,
  id,
  type = 'secondary',
  small = true,
}: {
  loading?: boolean,
  onClick: () => void,
  tooltipText?: string,
  disabled?: boolean,
  className?: string,
  icon?: IconType,
  id?: string,
  type?: ButtonType,
  small?: boolean,
}) {
  const button = (
    <Button
      type={type}
      small={small}
      className={`action-button ${loading ? 'loading' : ''} ${className}`}
      disabled={loading || disabled}
      icon={loading ? undefined : icon}
      onClick={onClick}
      aria-label={tooltipText}
      id={id}
    >
      {loading && <Spinner size="sm" />}
    </Button>
  );

  if (!tooltipText) {
    return button;
  }

  return (
    <TooltipWrapper title={tooltipText}>
      {button}
    </TooltipWrapper>
  );
}
